<template>
    <div class="page fill-height">
        <v-container :class="{'d-flexpb-lg-16 px-lg-7 flex-column align-center justify-lg-center fill-height': !isAuthed}">

            <v-card :style="isAuthed ? 'max-width: 625px;' : ''" class="soft-shadow" :class="{'pa-lg-2': isAuthed, 'w-full': phoneOnly}">
                <div class="form-wrapper" :class="{'w-full': isAuthed}">
                    <div class="d-flex justify-center flex-column py-lg-3 mb-2">
                        <v-card-title class="font-weight-semibold pt-0">Contact Us</v-card-title>
                        <v-card-subtitle class="mb-0 pb-0">Need help? Send us a message...</v-card-subtitle>
                    </div>
                    <v-card-text>
                        <form @submit.prevent="submitAction">
                            <template v-if="!isAuthed">
                                <v-text-field hide-details class="mb-4" placeholder="Enter Your Name" label="Name" name="name" v-model="name" :loading="loading" :disabled="loading" outlined></v-text-field>
                                <v-text-field hide-details class="mb-4" placeholder="Enter Your Email" label="Email" name="email" v-model="email" :loading="loading" :disabled="loading" outlined></v-text-field>
                                <v-text-field hide-details class="mb-4" placeholder="Enter Your Phone Number (Optional)" label="Phone Number" name="phone" v-model="phone" :loading="loading" :disabled="loading" outlined></v-text-field>
                            </template>
                            <v-select hide-details class="mb-4" placeholder="Select Subject" label="Subject" name="subject" v-model="subject" :items="subjects" :loading="loading" :disabled="loading" outlined></v-select>
                            
                            <v-select v-if="!isReasonInput" hide-details class="mb-4" placeholder="Select Reason" label="Reason" name="reason" v-model="reason" :items="availableReasons" :loading="loading" :disabled="loading || !subject" outlined></v-select>
                            
                            <v-text-field v-if="isReasonInput" hide-details class="mb-4" placeholder="Enter Reason" label="Reason" name="reason" v-model="reason" :loading="loading" :disabled="loading" outlined></v-text-field>
                            
                            <v-textarea hide-details class="mb-5" rows="5" no-resize placeholder="Enter Message Details" label="Message" name="content" v-model="content" :loading="loading" :disabled="loading" outlined />
                            <v-btn type="submit" block depressed large :disabled="loading" color="primary" @click.prevent="submitAction">Submit</v-btn>
                        </form>

                        <template v-if="platform === 'ios' && isAuthed">
                            <v-divider class="my-5"></v-divider>
                            <div>
                                <h3 class="font-weight-bold strong-text--text d-flex justify-center align-center mb-2 mb-lg-3">
                                    <v-icon size="23" color="error" class="me-3">mdi-delete</v-icon>
                                    <span>Delete your account</span>
                                </h3>
                                <p class="text-center details-text muted--text">Sending account deletion request may take between 24 and 48 hours to be done.</p>
                                <v-btn outlined :disabled="sentTicket || loading" block color="error" class="mb-4" @click="deleteAccountDialog = true">
                                    <v-icon>mdi-delete-outline</v-icon>
                                    <span>Delete Account</span>
                                </v-btn>
                            </div>

                        </template>
                    </v-card-text>
                </div>
            </v-card>

            <v-dialog v-model="deleteAccountDialog" scrollable max-width="350" overlay-color="#000" overlay-opacity="0.75">
                <v-card>
                    <v-card-title class="mb-2">Delete Account</v-card-title>
                    <v-card-subtitle>Are you sure that you want to delete your account?</v-card-subtitle>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn text color="muted" @click="deleteAccountDialog = false" :disabled="loading">cancel</v-btn>
                        <v-btn text color="error" :disabled="loading" :loading="loading" @click="deleteAccountAction">confirm</v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </v-container>

        <slot name="footer" />
    </div>
</template>

<script>

// @ is an alias to /src
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    name: 'Help',
    data(){
        return {
            name: '',
            email: '',
            phone: '',
            subject: '',
            reason: '',
            content: '',
            loading: false,

            sentTicket: null,

            deleteAccountDialog: false,

            subjects: [
                'Registration',
                'Trial Management',
                'Assessment',
                'Payment/ Billing',
                'Class Management',
                'Schedule',
                'Support & Feedback',
                'Cancellation',
                'Technical Issues',
                'Ijazah',
                'General Inquiry',
                'Account Settings',
                'Gift',
                'Other'
            ],

            reasonsMap: {
                'Registration': [
                    'None',
                    'New Trial Inquiry',
                    'Registration Issue',
                    'No Trial Confirmation',
                    'Sign-up Error',
                    'Missing info in registration',
                    'Wrong details entered'
                ],
                'Trial Management': [
                    'None',
                    'Trial Follow-up',
                    'Change Trial Date',
                    'Trial reminder request',
                    'Trial teacher change'
                ],
                'Assessment': [
                    'None',
                    'Assessment Follow-up',
                    'Assessment reschedule request',
                    'Assessment not attended'
                ],
                'Payment/ Billing': [
                    'None',
                    'Payment Issue',
                    'Refund',
                    'Discount',
                    'Payment Link Issue',
                    'How to Pay',
                    'Wrong plan selected',
                    'Double charge'
                ],
                'Class Management': [
                    'None',
                    'Class Reschedule Request',
                    'Teacher No-show',
                    'Change Teacher Request',
                    'Wrong class assigned'
                ],
                'Schedule': [
                    'None',
                    'Schedule Time Error',
                    'Missed Class Makeup Request',
                    'Vacation Hold Request',
                    'Change Course Request',
                    'Need class reminders'
                ],
                'Support & Feedback': [
                    'None',
                    'Class Report Request',
                    'Quality Feedback',
                    'Complaint',
                    'Need mentor talk'
                ],
                'Cancellation': [
                    'None',
                    'Cancel Subscription Request',
                    'Request Refund',
                    'Pause request (On Hold)',
                    'Cancel trial'
                ],
                'Technical Issues': [
                    'None',
                    'App/Platform Technical Issue',
                    'Can\'t join Zoom',
                    'Video/Voice Not Working',
                    'Lag / Slow platform',
                    'Login problem',
                    'Reset password not working'
                ],
                'Ijazah': [
                    'None',
                    'Ijazah Course Enrollment',
                    'Ijazah Certificate — PDF',
                    'Ijazah Certificate — Hard Copy',
                    'Ijazah follow-up'
                ],
                'General Inquiry': [
                    'None',
                    'General info request',
                    'Class details inquiry',
                    'Certificate/level inquiry',
                    'Teacher info inquiry',
                    'Plans Inquiry',
                    'Pricing Inqury'
                ],
                'Account Settings': [
                    'None',
                    'Update Phone Number',
                    'Update Email',
                    'Password Reset',
                    'Change Time zone',
                    'Change personal info'
                ],
                'Gift': [
                    'None',
                    'Gift Enrollment',
                    'Gift Issue',
                    'Promo code not working'
                ],
                'Other': []
            }
        };
    },
    components: {
        
    },
    computed:{
        ...GlobalComputed,
        availableReasons() {
            if (!this.subject) return [];
            return this.reasonsMap[this.subject] || [];
        },
        isReasonInput() {
            return this.subject === 'Other';
        }
    },
    methods: {
        ...GlobalMethods,
        deleteAccountAction(){
            this.subject = 'Account Settings';
            this.reason = 'None';
            this.content = 'Account Deletion Request';
            this.submitAction();
        },
        validateEmail(email) {
            const regEx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return regEx.test(email);
        },

        validate(){
            if (this.subject && this.content.trim() && (this.name && this.email || this.isAuthed)){
                // Auto-generate title from subject and reason
                let title = this.subject;
                if (this.reason && this.reason !== 'None') {
                    title += ' - ' + this.reason;
                }
                
                if (this.isAuthed){
                    return {
                        subject: this.subject,
                        reason: this.reason || null,
                        title: title,
                        content: this.content,
                    }
                }
                return {
                    name: this.name,
                    email: this.email,
                    phone: this.phone || null,
                    subject: this.subject,
                    reason: this.reason || null,
                    title: title,
                    content: this.content,
                }
            }else{
                return false;
            }
        },
        reset(){
            this.email = '';
            this.name = '';
            this.phone = '';
            this.subject = '';
            this.reason = '';
            this.content = '';
        },
        submitAction(){
            if (!this.loading){
                this.sentTicket = null;
                let data = this.validate();
                if (data){
                    if (this.isAuthed || this.validateEmail(this.email)){
                        this.loading = true;
    
                        this.$store.dispatch('fastPostAction', {url: `/support-tickets`, data}).then((response)=>{
                            let id = response.data.data.id;
                            this.showMsg('Your message sent successfully, Ticket Id: #' + id, 'success');
                            this.loading = false;
                            this.sentTicket = id;
                            this.reset();
                            if (this.isAuthed){
                                window.setTimeout(()=>{
                                    this.$router.push({name: 'inbox'});
                                }, 500);
                            }
                            
                        }).catch(()=>{
                            this.showMsg('Error occurred during sending your request', 'error');
                            this.loading = false;
                        })                    
                    }else{
                        this.showMsg('Email is not valid', 'error');
                    }
                }else{
                    this.showMsg('Inputs are required');
                }
            }
        },
    },
    watch: {
        subject(newVal, oldVal) {
            if (newVal !== oldVal) {
                this.reason = '';
            }
        }
    },
    mounted(){
        

    }
}
</script>

<style lang="scss" scoped>

</style>